<template>
  <v-app id="inspire" style="background: #1a222c; overflow: hidden !important;">
    <offline @detected-condition="handleConnectivityChange"></offline>

    <v-card flat class="hidden-sm-and-down" style="padding:0 !important; width: 100%;    z-index: 10 !important;-webkit-app-region: drag !important;">
      <v-container fluid style="padding:0 !important;">
        <v-layout row>
          <div style="width: 100vw;">
           <v-toolbar style="color: #5eca33; background-color: #2562af;">
            <v-toolbar-title  class="ml-0 pl-0"></v-toolbar-title>
        <v-toolbar-items  class=" borderXwidth">
          <img src="/static/img/icons/logoonechat_full-white.png" style="height: 55px; border-radius: 10px;margin-left: 4vw;cursor: pointer;" @click="toPage('/homepage')">
        </v-toolbar-items>
        <v-spacer></v-spacer>
           <v-badge color="red" overlap v-model="show_bell" v-if="num_listalert != 0" style="display: inline-grid !important;">
              <span slot="badge" v-if="num_listalert < 100" style="display: inline-grid !important;">{{num_listalert}}</span>
              <span slot="badge" v-else style="display: inline-grid !important;">99+</span>

              <v-menu offset-y style="z-index: 11;">
                <v-btn  slot="activator"  flat fab medium>
                  <v-icon style="color: white;">mdi-bell-ring-outline</v-icon>
                </v-btn>
                <v-list style="min-width: 210px;">
                  <v-list-tile :class="(item.state == 'true')? 'activelistbell': ''" v-for="item in listalert_bell" :key="item.announce_id" style="width: 100% !important;height: 37px;">
                    <v-list-tile-title v-if="item.state == 'true'" @click="dialog_bell(item)" style="cursor: pointer;">
                      <v-icon style="font-size: 18px;">mdi-bell-ring-outline</v-icon>
                      <span class="text-span" style="font-size: 15px;">{{ item.message }}</span>
                    </v-list-tile-title>
                    <v-list-tile-title v-else-if="item.state == 'false'">
                      <v-icon style="color: #aeb5bb !important;font-size: 18px;">mdi-bell-off-outline</v-icon>
                      <span class="text-span-dis" style="font-size: 15px;">{{ item.message }}</span>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-badge>

            <v-menu offset-y style="z-index: 11;" v-else>
                <v-btn slot="activator" flat fab medium>
                  <v-icon style="color: white;">mdi-bell-ring-outline</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile :class="(item.state == 'true')? 'activelistbell': ''" v-for="item in listalert_bell" :key="item.announce_id" style="width: 100% !important;height: 37px;">
                    <v-list-tile-title v-if="item.state == 'true'" @click="dialog_bell(item)" style="cursor: pointer;">
                      <v-icon>mdi-bell-ring-outline</v-icon>
                      <span class="text-span">{{ item.message }}</span>
                    </v-list-tile-title>
                    <v-list-tile-title v-else-if="item.state == 'false'">
                      <v-icon style="color: #aeb5bb !important;">mdi-bell-off-outline</v-icon>
                      <span class="text-span-dis">{{ item.message }}</span>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
        <v-toolbar-items>
          <v-btn class="fontset"  @click="toPage('/chat/settings/profile')" flat>
            <v-avatar size="50px"   style="margin-right: 1vw !important;">
              <img v-if="profilepicture != ''" :src="profilepicture" class="alligator-turtle" style="cursor: pointer;">
              <img v-else-if="typeuser === 'company'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="cursor: pointer;">
              <img v-else-if="typeuser === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="cursor: pointer;">
              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle" style="cursor: pointer;">
            </v-avatar>
            <p class="textlayoutnavbar">{{name}}</p>
          </v-btn>
          <header class="header" style="z-index: 8 !important;" id="headerMenubar">
    <nav class="header__nav" >
      <ul class="header__navbar">
        <li class="header__item">
          <a class="header__link">
            <transition name="slide-fade">
              <button class="header--btn" v-if="show" key="on" @click="show = false">
                  <v-icon class="header--icon" >clear</v-icon>
              </button>
              <button class="header--btn" v-else key="off" @click="show = true">
                  <v-icon  class="header--icon">arrow_drop_down</v-icon>
              </button>
            </transition>
          </a>
          <transition name="dropdown">
            <div class="header__dropdown-menu" v-bind:class="{ active: show }" v-if="show">
              <ul class="header__dropdown-menu-nav">
                <li class="header__dropdown-menu-item" @click="openQRcode()">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">mdi-qrcode</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{$t('HeaderMenubar.qrcode')}}
                    </div>
                  </a>
                </li>
                <li class="header__dropdown-menu-item" @click="openloa()">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon small class="header--icon--menu">fas fa-user-shield</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{$t('HeaderMenubar.loa')}}
                    </div>
                  </a>
                </li>
                <li class="header__dropdown-menu-item" v-for="(item, index) in listmenu"  @click="toPage(item.dialog)">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">{{item.icon}}</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{ item.title }}
                    </div>
                  </a>
                </li>
                <hr>
                <li class="header__dropdown-menu-item"  @click="logout()">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">lock_open</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{$t('HeaderMenubar.logout')}}
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </transition>
        </li>
      </ul>
    </nav>
  </header>

  <div>
    <!-- {{$i18n.locale}} -->
  <v-menu offset-y style="z-index: 11;">
    <img v-if="$i18n.locale == 'th'" slot="activator" src='/static/flag/thailand.svg' class="iconLanguage"></img>
    <img v-else-if="$i18n.locale == 'en'" slot="activator" src='/static/flag/united-kingdom.svg' class="iconLanguage"></img>
    <!-- <img v-else slot="activator" src='/static/flag/china.png' class="iconLanguage"></img> -->
  <v-list>
    <v-list-tile @click="changeLan('th')">
      <v-list-tile-title>
        <img src='/static/flag/thailand.svg' style="height: 20px;"/>&nbsp;&nbsp;ไทย
      </v-list-tile-title>

      </v-list-tile>
      <v-list-tile @click="changeLan('en')">
      <v-list-tile-title>
        <img src='/static/flag/united-kingdom.svg' style="height: 20px;"/>&nbsp;&nbsp;ENG
      </v-list-tile-title>
      </v-list-tile>
   <!--     <v-list-tile @click="changeLan('cn')">
      <v-list-tile-title>
        <img src='/static/flag/china.png' style="height: 20px;"/>&nbsp;&nbsp;简体中文
      </v-list-tile-title>
      </v-list-tile> -->
    </v-list>
  </v-menu>
</div>

</v-toolbar-items>

      </v-toolbar>

          </div>
        </v-layout>
      </v-container>
    </v-card>
<!--     <v-snackbar
        :timeout="60000"
        :top="true"
        :bottom="false"
        :right="false"
        :left="false"
        :multi-line="false"
        :vertical="false"
        v-model="snackbar"
      >
        {{ textsnackbar }}
        <v-btn flat color="pink" @click.native="snackbar = false">Close</v-btn>
      </v-snackbar> -->


    <v-layout v-if="$router.currentRoute.path !== '/onemeeting'" row wrap class="hidden-sm-and-down">
      <v-flex md3 lg3 xl3 class="hidden-sm-and-down" >
         <LeftSide/>
      </v-flex>
      <v-flex md9 lg9 xl9 style="overflow: hidden !important; background-color: white !important; height: calc(100vh - 64px) !important;">
        <router-view></router-view>
      </v-flex>
    </v-layout>

    <v-layout v-else row wrap justify-start class="hidden-sm-and-down">
      <!-- <v-flex md1 lg1 xl1 class="hidden-sm-and-down">
         <LeftSideOnemeet/>
      </v-flex>
      <v-flex md11 lg11 xl11 style="overflow: hidden !important; background-color: white !important; height: calc(100vh - 64px) !important;">
        <router-view></router-view>
      </v-flex> -->
      <!-- <v-row v-else justify="start" class="hidden-sm-and-down"> -->
        <v-col cols="1" sm="1" md="1" lg="1" style="width: 4vw;">
          <LeftSideOnemeet/>
        </v-col>
        <v-col cols="11" sm="11" md="11" lg="11" style="overflow: hidden !important; background-color: white !important; height: calc(100vh - 64px) !important; width: 96vw;">
          <router-view></router-view>
        </v-col>
      <!-- </v-row> -->
    </v-layout>

    <ShowQRCodeUser :dialogShowQRCode="dialogShowQRCode" @closeShowQRCodeUser="closeShowQRCodeUser"></ShowQRCodeUser>
    <AgoraCallDialog :AgoraCallDialog="AgoraCallDialog" :AgoraOption="AgoraOption" :infor_call="infor_call" :tokenuser="token" @decline_call="decline_call" @closeAgoraDialog="closeAgoraDialog"></AgoraCallDialog>
    <checkconsentOnechatDialog :url_consent="url_consent" :consentOnechatDialog="consentOnechatDialog" @closeDialogConsentOnechat="closeDialogConsentOnechat"></checkconsentOnechatDialog>
    <newConsent :newConsentDialog="newConsentDialog" :newConsentDetail="newConsentDetail" @closeNewConsent="closeNewConsent"/>
  </v-app>
</template>


<script>
import checkconsentOnechatDialog from '@/components/chat/dialog/consent/consent_onechat_dialog'
import ShowQRCodeUser from '@/components/chat/dialog/settings/ShowQRCodeUserDialog'
import LeftSide from '@/components/chat/layout/Lefttest'
import LeftSideOnemeet from '@/components/chat/onemeet/LefttestOnemeet'
import AgoraCallDialog from '@/components/chat/agora_call/ans_call_v2'
import newConsent from '@/components/consent/new_consent'
import offline from 'v-offline'
import { sync } from 'vuex-pathify'
import { Decode, Encode } from '@/services'
// import firebase from 'firebase'
var Centrifuge = require('centrifuge')
var centrifuge = new Centrifuge(process.env.WEB_centrifuge)


export default {
  data: () => ({
    newConsentDialog: false,
    newConsentDetail: {},
    AgoraCallDialog: false,
    AgoraOption: '',
    infor_call: {},
    one_id: '',
    show: false,
    show_bell: false,
    textsnackbar: '',
    snackbar: false,
    typeuser: '',
    profilepicture: '',
    name: '',
    token: '',
    status_login: '',
    num_listalert: 0,
    listalert_bell: [],
    listmenu: [],
    groupnameTest: '',
    dialogShowQRCode: false,
    windowWidth: '',
    consentOnechatDialog: false,
    url_consent: '',
  }),
  props: {
    source: String
  },
  methods: {
    closeNewConsent (value) {
      console.log("close new consent", value);
      this.newConsentDialog = value.close;
      this.newConsentDetail = {};
    },
    closeDialogConsentOnechat (value) {
      this.consentOnechatDialog = value
    },
    check_consent (token) {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var hour = String(today.getHours() + 1).padStart(2, '0')
      var minute = String(today.getMinutes()).padStart(2, '0')
      var seconds = String(today.getSeconds()).padStart(2, '0')
      var milsec = today.getMilliseconds()
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00'
        dd = String(today.getDate() + 1).padStart(2, '0')
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1'
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1'
            yyyy = today.getFullYear() + 1
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0')
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
      // console.log(today)
      var expireddate = Date.parse(today)
      // console.log(expireddate)
      var body = Encode.encodeRichmenu({ 'userid': token, 'expired_date': expireddate })
      // console.log(body)
      this.progress = true

      // check new consent
      if (this.$cookie.get(`check-consent-${token}`) === null || this.$cookie.get(`check-consent-${token}`) === undefined) {
        // test new consent
        this.progress = false
        this.newConsentDialog = true
        this.newConsentDetail = {token: token}
      } else {
        this.progress = false
        // // set localStorage authorization
        // localStorage.setItem('Authenrization', Encode.encode({'tokenuser': token, 'status_login': 'T', 'type_user': 'user'}))
        // if (localStorage.getItem('botid_redirect') !== null) {
        //   this.searchFriend(localStorage.getItem('botid_redirect'))
        // } else if (JSON.parse(localStorage.getItem('botid_redirect_url')) !== null) {
        //   // redirect bot room with url
        //   var data = JSON.parse(localStorage.getItem('botid_redirect_url'))
        //   this.$router.push(`/redirect-room?bot_token=${data.bot_id}&authorization=${data.auth}&url=${data.url}`)
        // } else {
        //   // console.log(`this.isMobile(): ${this.isMobile()}`)
        //   if (window.innerWidth <= 960) {
        //     this.$router.push('/mobile/homepage')
        //   } else {
        //     this.$router.push('/chat')
        //   }
        // }
      }
      // this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
      //   // console.log(response.data)
      //   if (response.data.status === 'success') {
      //     this.progress = false
      //     if (response.data.data.consent_check === 'false') {
      //       this.consentOnechatDialog = true
      //       this.url_consent = response.data.data.consent_url
      //     }
      //   }
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    searchFriend (botid) {
      var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      this.axios.post(process.env.APIsearchfriend, {
        tokenbot: botid,
        tokenuser: decoded.tokenuser
      }).then((response) => {
        // console.log(response.data.listuser)
        if (response.data.listuser.length === 0) {
          localStorage.removeItem('botid_redirect')
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        } else {
          if (response.data.listuser.relation === 'friend') {
            localStorage.removeItem('botid_redirect')
            if (window.innerWidth <= 960) {
              this.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom)
            } else {
              this.$router.push('/chat/room/' + response.data.listuser.user.tokenroom)
            }
          } else {
            console.log('not friend')
            this.$router.push('/addbot/' + localStorage.getItem('botid_redirect'))
          }
        }
      }).catch(error => {
        console.log(error)
        localStorage.removeItem('botid_redirect')
        if (window.innerWidth <= 960) {
          this.$router.push('/mobile/homepage')
        } else {
          this.$router.push('/chat')
        }
      })
    },
    decline_call (item) {
      console.log(item)
      // this.axios.post(process.env.APIalpine + `/api/v1/update-agora`, {
      //   tokenuser: this.token,
      //   tokenroom: item.tokenroom,
      //   tokenmessage: item.channel,
      //   time: '',
      //   message: 'cancel'
      // }).then((response) => {
      //   console.log(response)
      //   this.AgoraCallDialog = false
      // })
    },
    closeAgoraDialog (value) {
      this.AgoraCallDialog = value
    },
    changeLan (lang) {
      this.$i18n.locale = lang
      this.$cookie.set('language', lang)
      this.changeLangMenu()
    },
    get_oneid () {
      this.axios.get(process.env.APIgo_api + `/v1/getOneID/${this.token}`).then((response) => {
        if (response.data.status === 'success') {
          this.one_id = response.data.one_id
        }
      })
    },
    getuser () {
      // this.token = Decode.decodeToken(this.$cookie.get('tokenuser'))
      // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      // this.token = decoded['tokenuser']
      // this.$analytics.logEvent('use_chat', { decodeToken: Encode.encodeToken(this.token) })
      this.profilepicture = localStorage.getItem('profilepicture')
      this.name = localStorage.getItem('name')
      this.typeuser = localStorage.getItem('type_user')
      this.axios.post(process.env.APImanage + '/searchtokenuser', {
        tokenuser: this.token,
        tokenfriend: this.token
      }).then((response) => {
        var data = response.data.user
        if (response.data.status === 'success') {
          localStorage.setItem('profilepicture', data.profilepicture)
          localStorage.setItem('name', data.name)
          localStorage.setItem('usertype', data.usertype)
          this.profilepicture = data.profilepicture
          this.name = data.name
        }
      })
    },
    lengthstateactive (list) {
      return _.filter(list, function (list) { return list.state === 'true' }).length
    },
    getlistalert_bell () {
      this.axios.post(process.env.APImanage + '/getlistannounce', {}).then((response) => {
        this.listalert_bell = response.data.list_announce
        this.num_listalert = this.lengthstateactive(this.listalert_bell)
        // console.log(response.data)
      })
    },
    dialog_bell (item) {
      this.show_bell = false
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: item.message,
        type: 'warning',
        showCloseButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง'
      })
    },
    open (typecall, tokenroom) {
      // console.log(detailroom)
      // localStorage.setItem('detailroomCall', JSON.stringify(detailroom))
      // window.open('/video_call/answer/' + typecall + '/' + tokenroom, '_parent').focus()
      this.$router.push({path: '/video_call/answer/' + typecall + '/' + tokenroom, force: true})
    },
    handleConnectivityChange (status) {
      // console.log(status)
      if (!status) {
        this.snackbar = true
        this.textsnackbar = 'Network error! Please check your network connection.'
      }
    },
    openQRcode () {
      this.show = false
      this.dialogShowQRCode = true
    },
    openloa () {
      // window.open('/homepage#oneplatform', '_blank')
      var url = process.env.urlLoa
      var body = {
         "tokenuser": this.token,
         "url": url
        }
        this.axios.post(process.env.APInew_getaccesstoken, body).then((response) => {
          window.open(url + response.data.data.accesstoken, '_blank')
        })
    },
    closeShowQRCodeUser (value) {
      this.dialogShowQRCode = value
    },
    toPage (page) {
      this.show = false
      this.$router.push(page)
      this.pathsettings = page
    },
    clickservice () {
      window.open('/homepage#oneplatform', '_blank')
    },
    logout () {
      this.show = false
      // // this.$socket.emit('leave', {room: Decode.decodeToken(this.$cookie.get('tokenuser')), type: 'web'})
      // localStorage.clear()
      // try {
      //   this.$socket.emit('leave', {room: this.token, type: 'web'})
      // } catch(err) {
      //   console.log(err)
      // }
      this.$socket.emit('leave', {room: this.token, type: 'web'})
      // this.$cookie.delete("tokenuser")
      // this.$cookie.delete("status_login")
      localStorage.clear()
      // window.open(process.env.LogoutOneid, '_parent')
      console.log(this.$cookie.get('logouturl'))
      var logouturl = this.$cookie.get('logouturl')
      if (process.env.LogoutOneid) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          window.open(process.env.LogoutOneid, '_parent')
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          this.$router.push({path: '/', force: true})
        }
      }
      // this.$router.push({path: '/login', force: true})
    },
    noti_msg (name, notimsg, room, pic, type) {
      if (pic === '') {
        if (type === 'business') {
          pic = '/static/img/default_profile/business-white.png'
        } else if (type === 'bot') {
          pic = '/static/img/default_profile/bot-white.png'
        } else {
          pic = '/static/img/default_profile/man-white.png'
        }
      }
      if (Notification.permission === 'granted') {
        var me = this
        var notification = new Notification('New message from ' + name, {body: notimsg, icon: pic, silent: true})
        notification.onclick = function () {
          // window.open('/chat/room/' + room, '_parent').focus()
          me.$router.push('/chat/room/' + room)
        }
      } else {
        Notification.requestPermission().then(function (result) {
          console.log(result)
        })
      }
    },
    other_noti (title, notimsg, pic) {
      if (pic === '') {
        pic = '/static/img/default_profile/man-white.png'
      }
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, { body: notimsg, icon: pic, silent: true })
        notification.onclick = function () {
          window.open('', '_parent').focus()
        }
      } else {
        Notification.requestPermission().then(function (result) {
          console.log(result)
        })
      }
    },
    changeLangMenu () {
      this.listmenu =[
        {
          title: this.$t('HeaderMenubar.editProfile'),
          icon: 'person',
          dialog: '/chat/settings/profile'
        },
        // {
        //   title: this.$t('HeaderMenubar.sendOnebox'),
        //   icon: 'file_upload',
        //   dialog: '/chat/settings/uploadfile/onebox'
        // },
        {
          title: this.$t('HeaderMenubar.feedback'),
          icon: 'feedback',
          dialog: '/chat/settings/feedback'
        },
        {
          title: this.$t('HeaderMenubar.support'),
          icon: 'contact_support',
          dialog: '/chat/settings/support'
        },
        {
          title: this.$t('HeaderMenubar.policy'),
          icon: 'book',
          dialog: '/chat/settings/policy'
        }
      ]
    }
  },
  components: {
    LeftSide,
    LeftSideOnemeet,
    ShowQRCodeUser,
    AgoraCallDialog,
    offline,
    checkconsentOnechatDialog,
    newConsent
  },
  computed: {
    ...sync('*')
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
    var me = this
    $(document).click(function(event) {
      var target = $(event.target);
      if(!target.closest('#headerMenubar').length && $('#headerMenubar').is(":visible")) {
        me.show = false
      }
      if(!target.closest('#headerMenubar_bell').length && $('#headerMenubar_bell').is(":visible")) {
        me.show_bell = false
      }
      //  else if(!target.closest('#menu-sticker').length && $('#menu-sticker').is(":visible")) {
      //   me.sheetsticker = false
      //   // $('#menu-sticker').fadeOut(1600);
      // }
    })
  },
  watch: {
    '$socket.connected' (data) {
      console.log(this.$socket)
    },
    myprofilepicture () {
      this.profilepicture = localStorage.getItem('profilepicture')
    },
    myname () {
      this.name = localStorage.getItem('name')
    },
    windowWidth () {
      if (this.windowWidth <= 960) {
        if (window.location.pathname === '/chat/settings/profile') {
          this.$router.push('/mobile/settings/profile')
        } else if (window.location.pathname === '/chat/settings/uploadfile/onebox') {
          this.$router.push('/mobile/settings/uploadfile/onebox')
        } else if (window.location.pathname === '/chat/settings/feedback') {
          this.$router.push('/mobile/settings/feedback')
        } else if (window.location.pathname === '/chat/settings/support') {
          this.$router.push('/mobile/settings/support')
        } else if (window.location.pathname === '/chat/settings/policy') {
          this.$router.push('/mobile/settings/policy')
        } else if (window.location.pathname === '/chat/settings/managefriend') {
          this.$router.push('/mobile/settings/managefriend')
        } else if (window.location.pathname === '/chat/room/' + this.$route.params.roomid) {
          // this.$router.push('/mobile/room/' + this.$route.params.roomid)
          this.$router.push('/mobile/progress/' + this.$route.params.roomid)
        } else {
          this.$router.push('/mobile/homepage')
        }
      }
    }
  },
  sockets: {
    connect () {
      console.log('socket connected')
      this.$socket.emit('join', {room: this.token, type: 'web'})
      this.snackbar = true
      this.textsnackbar = 'server connected'
    },
    disconnect () {
      console.log('socket disconnected')
      this.snackbar = true
      this.textsnackbar = 'server disconnected'
      // You appear to be offline
    },
    expired_login (data) {
      console.log('expired_login')
      // console.log(data)
      this.socketexpire_login = data
    },
    // message (data) {
    //   console.log('socket message')
    //   // console.log(data)
    //   if (data.hasOwnProperty('tokenuser')) {
    //     this.axios.post(process.env.APIalpine + '/api/v3/getmessage', {tokenmessage: data.tokenmessage, tokenuser: this.token}).then((response) => {
    //       this.socketmessage = response.data.source
    //       if (data.tokenroom !== this.$route.params.roomid && data.tokenuser !== this.token) {
    //         if (response.data.source.typeofmessage !== 'message') {
    //           this.noti_msg(response.data.source.nickname, 'Send:  ' + response.data.source.typeofmessage + ' to you', response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
    //         } else {
    //           // can't use this.convertMention
    //           this.noti_msg(response.data.source.nickname, 'Message:  '  + ((response.data.source.message).replace(/\<tax>/g,'@')).replace(/<\/tax>/g,''), response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
    //         }
    //       }
    //     })
    //   }
    //   // keep type option agora call
    //   if (data.option !== undefined) {
    //     this.typeAgoraCall = data.option
    //     console.log(this.typeAgoraCall)
    //   }
    // },
    // update_agora (data) {
    //   console.log('update agora')
    //   // console.log(data)
    //   this.socket_update_agora = data
    // },
    convertMention(msg) {
      msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2;">@');
      msg = msg.replace(/<\/tax>/g,'</span>');
      // console.log(msg)
      return msg
    },
    // event_unsend (data) {
    //   // console.log(data)
    //   console.log('event_unsend')
    //   this.socket_unsendmessage = data
    // },
    event_kick_group (data) {
      console.log('event_kick_group')
      // console.log(data)
      this.socket_kickmember = data
    },
    // quick_reply (data) {
    //   console.log('quick_reply')
    //   this.socketquickreply = data
    // },
    // disable_quick_reply (data) {
    //   console.log('disable_quick_reply')
    //   this.socketdisablequickreply = data
    // },
    // disable_approve (data) {
    //   console.log('disable_approve')
    //   this.socketdisableapprove = data
    // },
    event_note (data) {
      console.log('event_note')
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.socketnote = data
      }
    },
    event_block (data) {
      console.log('event_block')
      if (data.hasOwnProperty('tokenuser')) {
        this.socketblock = data
      }
    },
    event_friend (data) {
      console.log('event_friend')
      this.socketfriend = data
      if (data.konAdd !== this.token) {
        this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: data.tokenfriend}).then((response) => {
          // console.log(response.data)
          if (response.data['user'][0]['type'] !== 'company') {
            this.other_noti('Friend Request', 'Request friend from ' + response.data['user'][0]['name'], response.data['user'][0]['profilepicture'])
          }
        })
      }
    },
    event_accept_friend (data) {
      console.log('event_accept_friend')
      // console.log(data)
      this.socketaccept_friend = data
      this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: [data.tokenfriend]}).then((response) => {
        if (response.data['user'][0]['type'] !== 'business') {
          this.other_noti('Accept Friend', 'You and ' + response.data['user'][0]['name'] + ' are friend.', response.data['user'][0]['profilepicture'])
        }
      })
    },
    event_remove_request_friend (data) {
      console.log('event_remove_request_friend')
      this.socketremove_request_friend = data
    },
    event_remove_friend (data) {
      console.log('event_remove_friend')
      this.socketremove_friend = data
    },
    event_create_group (data) {
      console.log('event_create_group')
      // console.log(data)
      this.socketcreate_group = data
      if (data.fromtokenuser !== this.token) {
        this.axios.post(process.env.APImanage + '/getgroup', {group_id: data.groupid, tokenuser: data.fromtokenuser}).then((response) => {
          this.groupnameTest = response.data.group.name
          this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: [data.fromtokenuser]}).then((responsed) => {
            // console.log(responsed.data)
            this.other_noti('Create group', 'Invite group', responsed.data['user'][0]['name'] + ' invite you to group ' + this.groupnameTest, responsed.data['user'][0]['profilepicture'])
          })
        })
      }
    },
    event_invite_group (data) {
      console.log('event_invite_group')
      // console.log(data)
      this.socketinvite_group = data
      if (data.userinvited !== this.token) {
        this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: [data.userinvited]}).then((responsed) => {
          this.other_noti(data.message, responsed.data['user'][0]['profilepicture'])
        })
      }
    },
    event_active_group (data) {
      console.log('event_active_group')
      // console.log(data)
      this.socketactive_group = data
      if (data.tokenuser !== this.token) {
        this.axios.post(process.env.APImanage + '/getgroup', {group_id: data.groupid, tokenuser: this.token}).then((response) => {
          this.groupnameTest = response.data.group.name
          this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: [data.tokenuser]}).then((responsed) => {
            this.other_noti('Accept group', responsed.data['user'][0]['name'] + ' accept group ' + this.groupnameTest, responsed.data['user'][0]['profilepicture'])
          })
        })
      }
    },
    event_cancel_group (data) {
      console.log('event_cancel_group')
      // console.log(data)
      this.socketcencel_group = data
    },
    event_leave_group (data) {
      console.log('event_leave_group')
      this.socketleave_group = data
    },
    event_update_user (data) {
      console.log('event_update_user')
      // console.log(data)
      if (data.tokenuser === this.token) {
        this.socketupdate_self = data
        if (data.type_update === 'status') {
          this.mystatus = data.update_data
          localStorage.setItem('status', data.update_data)
        } else if (data.type_update === 'pictureprofile') {
          this.myprofilepicture = data.update_data
          localStorage.setItem('profilepicture', data.update_data)
        } else if (data.type_update === 'name') {
          this.myname = data.update_data
          localStorage.setItem('name', data.update_data)
        }
      } else {
        this.socketupdate_friend = data
      }
    },
    send (data) {
      console.log(data)
    },
    signaling_message: function (data) {
      var me = this
      // console.log(data)
      var message = JSON.parse(data.message)
      console.log('signaling_message')
      // if (data.type === 'SDP' && data.typesend === 'offer' && localStorage.getItem('Calling') !== 'true') {
      if (data.type === 'SDP' && data.typesend === 'offer') {
        if (message.sdp.type === 'offer' && data.name !== this.token) {
          // this.socketsignaling_message = data
          localStorage.setItem('stateCall', 'true')
          localStorage.setItem('socketsignaling_message', JSON.stringify(data))
          this.other_noti('มีสายเรียกเข้า', data.fullname + ' ต้องการสนทนากับคุณ', data.picture)
          this.open(data.typecall, data.room)
        }
      }
    },
    announce_room (data) {
      this.socket_announce = data
    },
    edit_task (data) {
      this.socket_edittask = data
    },
    delete_task (data) {
      this.socket_deletetask = data
    },
    // disable_official_template (data) {
    //   this.socket_official_template = data
    // },
    // close_webview (data) {
    //   this.socket_close_webview = data
    // },
    // switch_keyboard (data) {
    //   console.log('switch_keyboard')
    //   console.log(data)
    // },
    // switch_richmenu (data) {
    //   console.log('switch_richmenu')
    // },
    message_read (data) {
      // console.log('message read')
      // console.log(data)
    }
  },
  created () {
    // console.log(this.$router.currentRoute.path)
    // console.log(this.$analytics)
    // // analytic.logEvent('notification_received')
    // // analytic.logEvent('goal_completion', { name: 'lever_puzzle'})
    // // gtag('event', 'sign_up', { 'method': 'Google' })
    // console.log(this.$analytics.logEvent('test24', { method: 'Google' }))
    // this.$analytics.logEvent("notification_received")
    // this.$analytics.logEvent('momo', { method: 'Vue' })
    // var firebaseConfig = {
    //   apiKey: "AIzaSyDliKV5rvjsLNNK_AxSrcRl5sDUMS_hQF8",
    //   authDomain: "onechat-de3fe.firebaseapp.com",
    //   databaseURL: "https://onechat-de3fe.firebaseio.com",
    //   projectId: "onechat-de3fe",
    //   storageBucket: "onechat-de3fe.appspot.com",
    //   messagingSenderId: "501136854127",
    //   appId: "1:501136854127:web:5b2629b97804c79169919a"
    // };
    // // Initialize Firebase
    // firebase.initializeApp(firebaseConfig);
    // firebase.analytics().logEvent('notification_received');
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    this.changeLangMenu()
    this.getuser()
    this.get_oneid()
    // this.check_consent(this.token)
    // this.status_login = this.$cookie.get('status_login')
    // if (this.status_login !== 'T' || this.status_login === null) {
    //   localStorage.setItem('pathRoom', this.$router.currentRoute.path)
    //   this.$router.push('/login')
    // } else {
    this.getlistalert_bell()
    this.$socket.emit('join', {room: this.token, type: 'web'})

    var me = this
    var events = ''
    var data_msg = ''
    centrifuge.setToken(process.env.centrifuge_key);
    centrifuge.subscribe(me.token, function(message) {
      // console.log(message)
      events = message.data.event
      data_msg = message.data.data
      console.log(`centrifuge: ${events}`)
      // console.log(data_msg)
        if (events === 'message') {
          if (data_msg.last_tokenmessage !== undefined) {
            // event unsend
            me.socket_unsendmessage = data_msg
          } else {
            // ถ้าข้อความเป็น type official_template, system เก็ทข้อความแบบเดิม ส่วน type อื่นรับปกติ
            if (data_msg.typeofmessage === 'official_template' || data_msg.typeofmessage === 'system' || data_msg.typeofmessage === 'system_action_albums') {
              me.axios.post(process.env.APIalpine + '/api/v3/getmessage', {tokenmessage: data_msg.tokenmessage, tokenuser: me.token}).then((response) => {
                me.socketmessage = response.data.source
              })
            } else {
              // event message
              me.socketmessage = data_msg
            }
            // console.log(me.socketmessage)
            if (data_msg.option !== undefined) {
                me.typeAgoraCall = data_msg.option
            }
          }
          if (me.socketmessage.tokenroom !== me.$route.params.roomid && me.socketmessage.tokenuser !== me.token) {
            if (me.socketmessage.typeofmessage !== 'message') {
              me.noti_msg(me.socketmessage.nickname, 'Send:  ' + me.socketmessage.typeofmessage + ' to you', me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type)
            } else {
              // can't use this.convertMention
              me.noti_msg(me.socketmessage.nickname, 'Message:  '  + ((me.socketmessage.message).replace(/\<tax>/g,'@')).replace(/<\/tax>/g,''), me.socketmessage.tokenroom, me.socketmessage.path_pic, me.socketmessage.type)
            }
          }
        } else if (events === 'disable_quick_reply') {
          me.socketdisablequickreply = data_msg
        } else if (events === 'update-agora') {
          me.socket_update_agora = data_msg
          me.AgoraCallDialog = false
        } else if (events === 'accept_call') {
          me.socket_accept_call = data_msg
          // console.log(me.socket_accept_call)
        } else if (events === 'service_call_agora') {
          // keep type option agora call
          // if (data_msg.option !== undefined) {
          if (process.env.NODE_ENV === 'development') {
            // ถ้ายังไม่ได้กดเข้าห้องแชทแต่มันการ call
            // if (me.$router.currentRoute.path === '/chat') {
            var typeCall = ''
            if (data_msg.option === 'voice') {
              typeCall = 'audio'
            } else {
              typeCall = data_msg.option
            }
              // call agora
              setTimeout(function() {
                var infor = {
                  agora_token: data_msg.agora_token,
                  channel: data_msg.channel,
                  nickname: data_msg.nickname,
                  option: typeCall,
                  picture: data_msg.picture,
                  tokenroom: data_msg.tokenroom,
                  one_id: me.one_id
                }
                me.infor_call = infor
                me.AgoraOption = typeCall
                me.AgoraCallDialog = true
                // console.log(me.AgoraCallDialog)
                // console.log(me.infor_call)
              }, 1000);
            // } else {
              // me.typeAgoraCall = data_msg
            // }
            // console.log(me.typeAgoraCall)
          }
          // }
        } else if (events === 'disable_approve') {
          me.socketdisableapprove = data_msg
        } else if (events === 'quick_reply') {
          me.socketquickreply = data_msg
        } else if (events === 'close_webview') {
          me.socket_close_webview = data_msg
        } else if (events === 'switch_keyboard') {
          me.socket_switch_keyboard = data_msg
        } else if (events === 'switch_richmenu') {
          me.socket_switch_richmenu = data_msg
        } else if (events === 'disable_official_template') {
          me.socket_official_template = data_msg
        } else if (events === 'drop_menu') {
          me.socket_drop_menu = data_msg
        } else if (events === 'consent') {
          // me.consentOnechatDialog = false
          me.centrifuge_consent = data_msg
        }
    });

    centrifuge.on('connect', function() {
        console.log("connected centrifuge");
    });
    centrifuge.on('disconnect', function() {
        console.log("disconnected centrifuge");
    });
    centrifuge.connect();
  }
}
</script>
<!-- <style type="text/css" scoped>


</style> -->

<style lang="css" scoped>
.scrolling-wrapper-y {
  /*display: flex;*/
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.scrolling-wrapper-y::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper-y::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.text-span {
  white-space: nowrap;
  /*width: 100px;*/
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
}
.text-span-dis {
  white-space: nowrap;
  /*width: 100px;*/
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
  color: #aeb5bb;
}

 b {
    font-weight: 900 !important;

  }

.tabss{
  background-color: #1da1f2 !important;
}
.tabs__bar .icon--right {
    right: 10px !important;
}
.tabs__bar .icon--left {
    left: 10px !important;
}

.tabs:not(.tabs--grow):not(.tabs--mobile) .tabs__item {
    padding: 0 15px !important;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.text {
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
  padding-top: 0px;
  font-family: 'CS ChatThaiUI' !important;
}
.textlayout {
  white-space: nowrap;
  width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
/*  padding-right: 0vw;
  padding-top: 1vh;
  padding-left: 2vw; */
  padding: 0;
  font-family: 'CS ChatThaiUI' !important;
  font-size: 18px;
  /*padding-bottom: 0px; */
  text-transform: none;
}
span.badge__bage.red {
  left: 27px;
}
.icon {
  font-size: 25px!important;
}
/*.badge--overlap .badge__badge {
  top: -12px;
  right: -9px;
}*/
.application .theme--light.list .list__tile:not(.list__tile--active), .theme--light .list .list__tile:not(.list__tile--active) {
  padding: 0 !important;
}
/*.application .theme--light.list, .theme--light .list {
  padding: 2vw !important;
}*/
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.listmenuweb {
  padding-left: 8px !important;
}
.list {
  padding-left: 8px !important;
}

>>>.v-expansion-panel__header {
  padding: 10px;
}
.nameProfile {
  color: white;
}

.nameProfile:hover {
 color: #d2d2d2;
}

.fontset{
  font-weight: bold !important;
  font-family: 'CS ChatThaiUI' !important;
  font-size:17px !important;
  /*font-weight: 900px;*/
}
.textlayoutnavbar {
  white-space: nowrap;
  width: 5em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0vw;
  padding-top: 1vh;
  padding-left: 0vw !important;
  font-family: 'CS ChatThaiUI', sans-serif !important;
  font-size: 18px;
  padding-bottom: 0px;
  color: white;
  text-transform: none;
}

div.borderXwidth a:before, div.borderXwidth a:after
{
    position: absolute;
    opacity: 0;
    width: 0%;
    height: 2px;
    content: '';
    background: gray;
    transition: all 0.3s;
}

div.borderXwidth a:before
{
    left: 0px;
    top: 0px;
}

div.borderXwidth a:after
{
    right: 0px;
    bottom: 0px;
}

div.borderXwidth a:hover:before, div.borderXwidth a:hover:after
{
    opacity: 1;
    width: 100%;
}
ul {
  margin: 0;
  padding: 0;
}

h1 { margin: 0 }
li { list-style: none; }
a { text-decoration: none; }

hr {
  border: 0;
  height: 0;
  margin: 1rem 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary {
  z-index: 8 !important;
}
.header {
  margin-top: 15px;
}
  .header__nav {
    position: relative;
  }
  .header__navbar {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
  }
  .header__item {
    padding: 1rem;
    position: relative;
  }
  .header--icon {
    font-size: 20px;
    color: white;
  }
  .header--icon--menu {
    color: gray;
  }
  .header--btn {
    top: 0;
    right: 0;
    position: absolute;
  }
  .header--btn:focus {
  outline:none;
}
  .header--icon, .header--icon--menu {
    fill: currentcolor;
    width: 1.65rem;
    height: 1.65rem;
    display: inline-flex;
  }
  .header--btn {
    cursor: pointer;
    padding: 0;
    display: inline-block;
    border: 1px solid transparent;
    background-color: transparent;
    appearance: none;
    user-select: none;
  }
  .header__dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    height: 24rem;
    min-width: 280px;
    overflow-y: auto;
    padding: 1rem 1rem 1rem 0;
    margin-top: 1rem;
    border-radius: 8px;
    background-color: white;
    border: 1px solid #dadce0;
    background-clip: padding-box;
  }
  .header__dropdown-menu-link {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    line-height: 0;
    color: #3c4043;
    padding: 0.6rem 1.5rem 0.6rem 1.5rem;
    margin-bottom: 0.4rem;
    border-radius: 0 50px 50px 0;
  }
  .header__dropdown-menu-link:hover {
      background-color: #b4d1f478;
      color: #2562af;
  }
  .header__dropdown-menu-link:hover .header--icon--menu {
    color: #2562af;
  }
  .header__dropdown-menu-link_disabled {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    line-height: 0;
    color: #bbbbbb;
    padding: 0.6rem 1.5rem 0.6rem 1.5rem;
    margin-bottom: 0.4rem;
    border-radius: 0 50px 50px 0;
  }
   .header__dropdown-menu-link_disabled:hover {
      background-color: none;
      color: #bbbbbb;
    }
    .header__dropdown-menu-link_disabled:hover .header--icon--menu {
        color: #bbbbbb;
      }
  .header__dropdown-menu-svg {
    padding-right: 16px;
  }
 .header__dropdown-menu-svg .header--icon {
      width: 1.40rem;
      height: 1.40rem;
    }
    .header__dropdown-menu-svg .header--icon--menu {
      width: 1.40rem;
      height: 1.40rem;
    }

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.6s;
}
.slide-fade-enter,
.slide-fade-leave-active {
  opacity: 0;
}
.slide-fade-enter {
  transform: translateX(31px);
}
.slide-fade-leave-active {
  transform: translateX(-31px);
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.6s;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary {
  z-index: 8 !important;
}
>>>.v-badge--overlap .v-badge__badge {
    top: 10px;
    right: 5px;
    display: inline-grid !important;
}
>>>.activelistbell:hover {
  background: #b4d1f478;
  /* color: #4796ff; */
}
/* .icon-listbell {
  color: #757575;
}
.icon-listbell:hover {
  color: #4796ff;
} */
>>>.v-list {
    /*min-width: 210px !important;*/
    max-width: 285px !important;
  }

.iconLanguage {
  height: 25px;
  cursor: pointer;
  margin-top: 17px;
}

/*.wrapper {
  height: 70vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .social {
    margin-top: 1rem;
  }
  a {
    padding: 0.6rem;
  }
  h1 {
    color: #42b983;
    font-size: 2rem;
    font-weight: 300;
  }
  p {
    color: #7f8c8d;
    font-weight: 100;
  }
  svg {
    fill: currentcolor;
    color: #b8c2cc;
    width: 1.65rem;
    height: 1.65rem;
    display: inline-flex;
  }
}*/
</style>



// WEBPACK FOOTER //
// src/components/chat/layout/Layout.vue